function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import SearchkitWrapper from '../Wrapper';
const SearchMoreLikeThis = _ref => {
  let {
    query,
    filter,
    children,
    ...props
  } = _ref;
  const requestOptions = {
    hooks: {
      beforeSearch: requests => {
        requests.forEach(request => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          request.body.query = {
            bool: {
              ...filter,
              must: [{
                more_like_this: query
              }]
            }
          };
        });
        return Promise.resolve(requests);
      }
    }
  };
  return /*#__PURE__*/React.createElement(SearchkitWrapper, _extends({}, props, {
    requestOptions: requestOptions
  }), children);
};
export default SearchMoreLikeThis;